import sanitizeHtml from "sanitize-html";

/**
 * Traverse the DOM tree from element to root nodes until predicateFn evaluates to true.
 *
 * returns:
 * - element in iteration when predicateFn evalutes on true
 * - null (documentElement.parent)if predicateFn never evaluates to true
 */
export function walkUpUntil(element, predicateFn) {
  let currentEl = element;

  do {

    if( ! currentEl) {
      return null;
    }

    if (currentEl.nodeType === Node.ELEMENT_NODE && predicateFn(currentEl)) {
      break
    }

    currentEl=  currentEl.parentNode;
  } while (!! currentEl);

  return currentEl
}

/**
 * Wraps a dom event with its own removeListener
 *
 * ```js
 * let event = DomEvent($aDiv, "click", e => foo() );
 * event.dispose();
 * ```
 */
export function DOMEvent(target, type, callback) {
  target.addEventListener(type, callback);
  return {
    dispose() {
      target.removeEventListener(type, callback)
    }
  }
}

/**
 * Tells if the scroll position inside an element is at element bottom minus threshold in pixels
 *
 * ```js
 * isScrollAtThresholdFromBottom($myScrollableDiv, 50) ;
 * ```
 */
export function isScrollAtThresholdFromBottom(element, threshold = 0) {
  return element.scrollHeight - element.scrollTop - element.clientHeight <= threshold
}

/**
 * Prevent xss injections
 * @param html
 */
export const sanitize = html => {
  return sanitizeHtml(html, {
    allowedTags: ["h1", "h2", "h3", "h4", "h5", "h6", "blockquote", "p", "a", "ul", "ol", "span",
      "nl", "li", "b", "i", "strong", "em", "strike", "code", "hr", "br", "div", "img",
      "table", "thead", "caption", "tbody", "tr", "th", "td", "pre"],
    allowedAttributes: {
      "*": ["style", "class", "id", "goto"],
      "a": ["href", "target"],
      "img": ["src", "alt", "width", "height"]
    },
    allowedSchemes: [ 'data', 'http', 'https' ]
  });
};


export const stripHTML = HTMLString => {
  var tmp = document.createElement("div");
  tmp.innerHTML = sanitize(HTMLString);
  return tmp.textContent || tmp.innerText || "";
};

const transitions = {
  "transition"      : "transitionend",
  "OTransition"     : "oTransitionEnd",
  "MozTransition"   : "transitionend",
  "WebkitTransition": "webkitTransitionEnd"
};

export function getTransitionEndEventName() {
  let bodyStyle = document.body.style;
  for(let transition in transitions) {
    if(bodyStyle[transition] != undefined) {
      return transitions[transition];
    }
  }
}
